// extracted by mini-css-extract-plugin
export default {"datepicker-wrapper":"templates-hotel-settings-activity-module__datepicker-wrapper","search-input":"templates-hotel-settings-activity-module__search-input"};